import { Reducer } from '@reduxjs/toolkit';
import { reducer as authReducer, AuthState } from './slices/authSlice';
// @ts-expect-error
import { reducer as customerReducer } from './slices/customerSlice';

const rootReducer: () => {
  auth: Reducer<AuthState>;
  customer: Reducer;
} = () => ({
  auth: authReducer,
  customer: customerReducer,
});

export default rootReducer;
